import React from "react";
import { Link } from "react-router-dom";
import bg21 from "../../assets/images/background/bg-21.png";
import bg9 from "../../assets/images/background/bg-9.png";
import teamOne from "../../assets/images/resource/managements/hr.jpeg";
import teamTwo from "../../assets/images/resource/managements/manager_hr_admin.png";
import teamThree from "../../assets/images/resource/managements/manager_fnb_ops.png";
import teamFour from "../../assets/images/resource/managements/executive_chef.png";
import teamFive from "../../assets/images/resource/managements/technical_manager.png";
import teamSix from "../../assets/images/resource/managements/account_manager.png";
import teamSeven from "../../assets/images/resource/managements/gm_purchase.png";
import teamEight from "../../assets/images/resource/managements/manager_it.png";
import teamNine from "../../assets/images/resource/managements/am_it_dm.png";
import teamTen from "../../assets/images/resource/managements/hk_supervisor.png";

const teams = [
  {
    name: "Lt Col. Saiful A Saleh, psc(Retd)",
    designation: "Director of HR & Admin",
    image: teamOne,
  },
  {
    name: "Md. Suel Pramanik",
    designation: "Manager, HR & Admin",
    image: teamTwo,
  },
  {
    name: "Md. Masum Parvez",
    designation: "Manager, F&B Operations",
    image: teamThree,
  },
  {
    name: "Mirajur Rahman",
    designation: "Executive Chef",
    image: teamFour,
  },
  {
    name: "Md. Shohel Miah",
    designation: "Technical Manager",
    image: teamFive,
  },
  {
    name: "Muhammad Al Mamun",
    designation: "Manager, Accounts",
    image: teamSix,
  },
  {
    name: "Md. Jahangir",
    designation: "General Manager, Purchase",
    image: teamSeven,
  },
  {
    name: "Md. Tahmid Hossain",
    designation: "Manager, IT",
    image: teamEight,
  },
  {
    name: "Md. Shamim-Al-Mamun",
    designation: "Asst. Manager, Digital Marketing",
    image: teamNine,
  },
  {
    name: "Md. Monerul Islam",
    designation: "Asst. Manager, Housekeeping",
    image: teamTen,
  },
];

function Teem() {
  return (
    <>
      <section className="team-section">
        <div className="left-bg">
          <img src={bg21} alt="" title="" />
        </div>
        <div className="right-bg">
          <img src={bg9} alt="" title="" />
        </div>
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle">
              <span>experienced team</span>
            </div>

            <div className="pattern-image">
              <img
                src={require("../../assets/images/icons/separator.svg").default}
                alt="mySvgImage"
              />
            </div>

            <h2>Meet Our Chef</h2>
          </div>
          <div className="row justify-content-center clearfix">
            {teams.map((team, index) => (
              <div
                key={index}
                className="team-block col-lg-4 col-md-6 col-sm-12"
              >
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="0ms"
                >
                  <div className="image">
                    <img src={team.image} alt="" />
                    <div className="overlay-box">
                      <div className="overlay-inner">
                        <ul class="social-box">
                          <li>
                            <Link
                              to="https://www.facebook.com/"
                              class="fab fa-facebook-f"
                            ></Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.twitter.com/"
                              class="fab fa-twitter"
                            ></Link>
                          </li>
                          <li>
                            <Link
                              to="https://dribbble.com/"
                              class="fab fa-dribbble"
                            ></Link>
                          </li>
                          <li>
                            <Link
                              to="https://www.linkedin.com/"
                              class="fab fa-linkedin"
                            ></Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="lower-content">
                    <h3>
                      <Link to="#">{team.name}</Link>
                    </h3>
                    <div className="designation">{team.designation}</div>
                    <div className="text desc">
                      Lorem Ipsum is simply dummy printing and typeset industry
                      lorem Ipsum has been the industrys.
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Teem;
